import React, { createContext, useState, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { createMuiTheme, ThemeProvider as MUIThemeProvider } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(false);

  const toggleTheme = () => {
    setDarkMode((prevMode) => !prevMode);
  };

  const theme = useMemo(
    () =>
      createMuiTheme({
        palette: {
          type: darkMode ? "dark" : "light",
        },
        typography: {
          fontFamily: '"Inter", sans-serif',
        },
        overrides: {
          MuiCssBaseline: {
            "@global": {
              body: {
                fontFamily: '"Inter", sans-serif',
              },
              button: {
                fontFamily: '"Inter", sans-serif',
              },
              input: {
                fontFamily: '"Inter", sans-serif',
              },
              textarea: {
                fontFamily: '"Inter", sans-serif',
              },
              select: {
                fontFamily: '"Inter", sans-serif',
              },
            },
          },
          MuiTypography: {
            root: {
              fontFamily: '"Inter", sans-serif',
            },
          },
          MuiButton: {
            root: {
              fontFamily: '"Inter", sans-serif',
            },
          },
          MuiInputBase: {
            root: {
              fontFamily: '"Inter", sans-serif',
            },
          },
        },
      }),
    [darkMode]
  );

  const contextValue = useMemo(() => ({ darkMode, toggleTheme }), [darkMode]);

  return (
    <ThemeContext.Provider value={contextValue}>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </ThemeContext.Provider>
  );
};
ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useThemeContext = () => useContext(ThemeContext);

